// 交互式分割操作
import { useContext, useEffect, useMemo, useRef } from "react"
import MattingOptCanvas from "../compoents/MattingOpt/MattingOptCanvas"
import { ExtractionContext } from "../ExtractionContext"
import eventBus from "@utils/eventBus"

const formartNumber = (number, digits=2) => {
    return Number(number.toFixed(digits))
}

const InteractiveMatting = (props) => {
    const canvasRef = useRef()
    const {
        inputImage,
        imageWidth,
        imageHeight,
        contentWidth,
        contentHeight,
        interactiveMode,
        paintMode,
        paintSize, setPaintSize,
        eraseSize, setEraseSize,
        interactiveNpy,

        binaryMask, setBinaryMask,
        modelBlendedMask, setModelBlendedMask,
        modelBlueMaskBase64, setModelBlueMaskBase64,

        setViewportOffset,
        moveable, setMoveable,
        zoom, setZoom,
        MIN_ZOOM, MAX_ZOOM,
    } = useContext(ExtractionContext)

    const displayScale = useMemo(() => {
        return contentWidth / imageWidth
    }, [contentWidth, imageWidth])

    const resetCanvas = () => {
        canvasRef.current.resetCanvas()
    }
    const clearCanvas = () => {
        canvasRef.current.clearCanvas()
    }
    const undoCanvas = (undo) => {
        canvasRef.current.undoCanvas(undo)
    }
    const redoCanvas = (redo) => {
        canvasRef.current.redoCanvas(redo)
    }
    useEffect(() => {
        eventBus.on(`image_extraction_reset_canvas_${props.uid}`, resetCanvas)
        eventBus.on(`image_extraction_clear_canvas_${props.uid}`, clearCanvas)
        eventBus.on(`image_extraction_undo_canvas_${props.uid}`, undoCanvas)
        eventBus.on(`image_extraction_redo_canvas_${props.uid}`, redoCanvas)
        return () => {
            eventBus.off(`image_extraction_reset_canvas_${props.uid}`, resetCanvas)
            eventBus.off(`image_extraction_clear_canvas_${props.uid}`, clearCanvas)
            eventBus.off(`image_extraction_undo_canvas_${props.uid}`, undoCanvas)
            eventBus.off(`image_extraction_redo_canvas_${props.uid}`, redoCanvas)
        }
    }, [])

    return (
        <MattingOptCanvas
            ref={canvasRef}
            inputImageUrl={inputImage}
            whiteMaskUrl={binaryMask}
            blueMaskBase64={modelBlueMaskBase64}
            setBlueMaskBase64={setModelBlueMaskBase64}
            setBlendedBlueMaskBase64={setModelBlendedMask}
            displayScale={displayScale}
            displayWidth={contentWidth}
            displayHeight={contentHeight}
            moveable={moveable}
            zoom={zoom}
            minZoom={MIN_ZOOM}
            maxZoom={MAX_ZOOM}
            setZoom={setZoom}
            setViewportOffset={setViewportOffset}
            interactiveMode={interactiveMode}
            paintMode={paintMode}
            paintSize={paintSize}
            setPaintSize={setPaintSize}
            eraseSize={eraseSize}
            setEraseSize={setEraseSize}
            addUndo={props.addUndo}
            addRedo={props.addRedo}
            clearRedo={props.clearRedo}
            setUpdated={() => {}}
            aiInteractiveNpy={interactiveNpy}
        />
    )
}

export default InteractiveMatting